import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TagInputs from "./inputs/TagInputs";
import Footer from "./Layout/Footer";
import logo from "../Assets/images/ConnectHealthPro.png";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';



const LandingPage = () => {
    const navigate = useNavigate();



    return (
        <div className="w-100">
            <div className="container landing-page" style={{ display: 'flex', minHeight: '100vh', minWidth: '100%' }}>
                <div className="left-section flex flex-direction-v ">
                    {/* <img src={logo} alt="connecthealthpro" srcset="" /> */}

                    <h1 className="m-t-20">Better Health, Connected</h1>
                    <p className="m-t10 m-b-10">Get your health records and tips right at your finger tips </p>
                    <button className="submit-btn m-b-10" onClick={() => navigate("/create-account")}>Create Account</button>
                    <button className="save-drafts" onClick={() => navigate("/login")}>Login</button>
                </div>
                <div className="col-7 no-padding no-margin">
                    <div className="banner"></div>
                </div>

            </div>
            <Footer />
        </div>
    );
};

const PersonalInfoPage = ({ nextStep, handleChange, renderStepper }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        
        if (date) {
            const formatted = date.toISOString().split('T')[0];
            // Simulate the onChange event that handleChange expects
            const event = {
                target: {
                    name: 'dateOfBirth',
                    value: formatted,
                    type: 'text'
                }
            };
            handleChange(event);
        } else {
            const event = {
                target: {
                    name: 'dateOfBirth',
                    value: '',
                    type: 'text'
                }
            };
            handleChange(event);
        }
    };

    return (
        <div className="w-100 banner-Glassy">
            <div className="container flex-direction-v center-text">
                {renderStepper()}
                <div className="container flex-h-center center-text col-6">
                    <div className="flex flex-h-center">
                        <img src="/SidebarLogo.png" alt="logo" />
                    </div>

                    <h2 className="m-t-20">Create Account</h2>
                    <h3>Personal Information</h3>
                    <div className="m-b-20">
                        <TagInputs onChange={handleChange} label="First Name" name="firstName" type="text" placeholder="First name" />
                        <TagInputs onChange={handleChange} label="Last Name" name="lastName" type="text" placeholder="Last name" />
                        <TagInputs onChange={handleChange} label="Phone" name="phoneNumber" type="text" placeholder="Phone Number" />
                        <TagInputs onChange={handleChange} label="Email" name="email" type="email" placeholder="Email Address" />
                        <div className='m-t-10'>
                            <div className='flex'>
                                <div className='label-box'>Date of Birth</div>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={handleDateChange}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    maxDate={new Date()}
                                    className="w-100"
                                    style={{
                                        height: "40px",
                                        border: "1px solid #3c7e2d73",
                                        borderRadius: "0px 4px 4px 0px",
                                        padding: "8px 12px"
                                    }}
                                    calendarClassName="border border-gray-200 rounded-xl shadow-xl"
                                    wrapperClassName="w-100"
                                />
                            </div>
                        </div>
                        <label>
                            <input name="terms" type="checkbox" /> I agree with the <a href="#">Terms & Conditions</a>
                        </label>
                    </div>
                    <button className="submit-btn m-b-20" onClick={nextStep}>Next</button>
                    <div className="tabs"></div>
                    <div className="w-100 flex flex-direction-v">
                        <button className="save-drafts m-b-10">Sign up with Google</button>
                        <button className="save-drafts m-b-10">Sign up with Facebook</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

const ContactAddressPage = ({ nextStep, states, prevStep, onSubmit, handleSelectChange, handleChange, renderStepper }) => {
    return (
        <div className="w-100">
            <div className="container flex-direction-v">
                {renderStepper()}
                <div className="container center-text col-6">
                    <img src="/SidebarLogo.png" alt="logo" />
                    <h2 className="m-t-20">Create Account</h2>
                    <h3>Contact Address</h3>
                    <div className="m-b-20">
                        <TagInputs onChange={handleChange} name="address" label="Address" type="text" placeholder="House Number, Street Name" />
                        <TagInputs onChange={handleChange} value={"Nigerian"} name="nationalityId" label="Nationality" placeholder="Select Country" />
                        <TagInputs onChange={handleSelectChange} options={states} name="stateId" label="State" type="R-select" placeholder="Select State" />
                        {/* <TagInputs onChange = {handleChange} options={nationalities} name="" label="LGA" type="R-select" placeholder="Select LGA" /> */}
                        <TagInputs onChange={handleChange} name="city" label="City" placeholder="Select City" />
                    </div>
                    <button className="submit-btn m-b-20" onClick={() => {
                        onSubmit();
                        nextStep();
                    }}>Next</button>
                    <button className="save-drafts m-b-20" onClick={prevStep}>Back</button>
                </div>
            </div>
        </div>
    );
};

export { LandingPage, PersonalInfoPage, ContactAddressPage };
